import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "main",
  class: "main"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("section", {
  class: "page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-light overlay-show overlay-op-5",
  style: {"background-image":"url(/img-custom/master-header.jpg)"}
}, null, -1)
const _hoisted_3 = { class: "container py-2" }
const _hoisted_4 = {
  class: "text-primary text-center font-weight-semibold",
  style: {"text-transform":"uppercase"}
}
const _hoisted_5 = { class: "blog-posts single-post" }
const _hoisted_6 = { class: "post post-large blog-single-post border-0 m-0 p-0" }
const _hoisted_7 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.record.titleIt), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("article", _hoisted_6, [
          _createElementVNode("div", {
            class: "post-content ml-0",
            innerHTML: _ctx.record.contentIt
          }, null, 8, _hoisted_7)
        ])
      ])
    ])
  ]))
}